import createSagaMiddleware from '@redux-saga/core';
import { configureStore, combineReducers, Action } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';

import rootSaga from '~sagas';

import authSlice from '~redux/slices/auth';
import dashboardSlice from '~redux/slices/dashboard';
import customerSlice from '~redux/slices/customer';
import navigationSlice from '~redux/slices/navigation';
import goldSlice from '~redux/slices/gold';
import branchSlice from '~redux/slices/branch';
import settingSlice from '~redux/slices/setting';
import adminSlice from '~redux/slices/admin';
import approvalSlice from '~redux/slices/approval';
import projectSlice from '~redux/slices/project';
import silverSlice from '~redux/slices/silver';

const sagaMiddleware = createSagaMiddleware();

const {
    createReduxHistory,
    routerMiddleware,
    routerReducer,
} = createReduxHistoryContext({
    history: createBrowserHistory(),
});

const rootReducer = combineReducers({
    router: routerReducer,
    auth: authSlice.reducers,
    dashboard: dashboardSlice.reducers,
    customer: customerSlice.reducers,
    navigation: navigationSlice.reducers,
    gold: goldSlice.reducers,
    branch: branchSlice.reducers,
    setting: settingSlice.reducers,
    admin: adminSlice.reducers,
    approval: approvalSlice.reducers,
    project: projectSlice.reducers,
    silver: silverSlice.reducers,
});

const resettableRootReducer = (state: ReturnType<typeof rootReducer> | undefined, action: Action) => {
    if (action.type === 'auth/authClearEntireStore') {
        return rootReducer(undefined, action);
    }

    return rootReducer(state, action);
};

export const store = configureStore({
    reducer: resettableRootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: false,
    }).concat(sagaMiddleware, routerMiddleware),
    devTools: process.env.REACT_APP_ENV !== 'prod',
});

sagaMiddleware.run(rootSaga);

export const history = createReduxHistory(store);
